import { useState } from "react";
import { cx, useTranslations } from "@jugl-web/utils";

import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { WorkspaceTile } from "../WorkspaceTile";
import { WorkspaceEmailVerificationDialog } from "./components/WorkspaceEmailVerificationDialog";
import { ReactComponent as EmailIcon } from "./assets/email.svg";

export const WorkspaceEmail = () => {
  const { t } = useTranslations();
  const { entity } = useEntitySelectedProvider();

  const [emailVerificationDialogIsOpen, setEmailVerificationDialogIsOpen] =
    useState(false);

  return (
    <>
      <WorkspaceTile
        onClick={() => setEmailVerificationDialogIsOpen(true)}
        buttonText={
          entity.isEmailVerified
            ? t({
                id: "common.edit",
                defaultMessage: "Edit",
              })
            : t({
                id: "common.verify",
                defaultMessage: "Verify",
              })
        }
      >
        <div className="flex flex-col items-center gap-3 duration-500 group-hover:mt-[-90px]">
          <EmailIcon />
          <div className="flex flex-col gap-[6px] text-center">
            <span className="text-dark-800 font-medium">
              {entity.billingEmail}
            </span>
            <span
              className={cx(
                "text-sm",
                entity.isEmailVerified
                  ? "text-[#828282]"
                  : "text-gradients-danger"
              )}
            >
              {entity.isEmailVerified
                ? t({
                    id: "workspace-page.workspace-email",
                    defaultMessage: "Workspace email",
                  })
                : t({
                    id: "workspace-page.workspace-email-verification-needed",
                    defaultMessage: "Email verification needed",
                  })}
            </span>
          </div>
        </div>
      </WorkspaceTile>
      <WorkspaceEmailVerificationDialog
        isOpen={emailVerificationDialogIsOpen}
        onRequestClose={() => setEmailVerificationDialogIsOpen(false)}
      />
    </>
  );
};
